// extracted by mini-css-extract-plugin
export default {"field_body":"baseInput_field_body__mrWfY","base_input":"baseInput_base_input__dCfh2","base_label":"baseInput_base_label__q7Uo7"};